// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingIndicator_root__qEoxa","fill":"LoadingIndicator_fill__WA9Ge"};